import { render } from "./BaseFooter.vue?vue&type=template&id=55216f6d&scoped=true"
const script = {}

import "./BaseFooter.vue?vue&type=style&index=0&id=55216f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55216f6d"]])

export default __exports__